import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Smartphone } from "lucide-react";
import { useAuth } from "../auth/AuthContext";
import PhoneOtpField from "./PhoneOtpField";
import { Modal } from "../pages/workspace/shared";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function PhoneVerifyBanner() {
  const { user, refresh } = useAuth();
  const [open, setOpen] = useState(false);
  const [phone, setPhone] = useState("");
  const [token, setToken] = useState("");
  const [busy, setBusy] = useState(false);
  if (!user || user.role === "admin" || user.role_pending || user.phone_verified) return null;

  const save = async () => {
    setBusy(true);
    try {
      await axios.post(`${API}/auth/phone/verify`, { phone, phone_token: token });
      toast.success("Mobile number verified");
      setOpen(false);
      await refresh();
    } catch (e) {
      toast.error(e?.response?.data?.detail || e?.message || "Could not verify");
    } finally { setBusy(false); }
  };

  return (
    <>
      <div data-testid="phone-verify-banner" style={{display:"flex",alignItems:"center",gap:10,flexWrap:"wrap",background:"#FEF3C7",border:"1px solid #FCD34D",borderRadius:10,padding:"10px 14px",margin:"0 0 16px",fontSize:13,color:"#92400E"}}>
        <Smartphone size={16}/>
        <span style={{flex:1,minWidth:220}}>Your mobile number{user.phone ? ` (${user.phone})` : ""} isn't verified yet. Verify it so you get order and payment alerts by SMS.</span>
        <button data-testid="phone-verify-open" className="primary-btn" style={{padding:"7px 14px"}} onClick={() => { setPhone(user.phone || ""); setToken(""); setOpen(true); }}>Verify now</button>
      </div>
      {open && (
        <Modal title="Verify your mobile number" close={() => setOpen(false)}>
          <div data-testid="phone-verify-modal" style={{display:"grid",gap:14}}>
            <PhoneOtpField testIdPrefix="pv-otp" phone={phone} setPhone={setPhone} token={token} setToken={setToken}/>
            <button data-testid="phone-verify-save" className="primary-btn" disabled={!token || busy} onClick={save}>{busy ? "Saving…" : "Save verified number"}</button>
          </div>
        </Modal>
      )}
    </>
  );
}
